module.exports = __webpack_public_path__ + "c42ca469dc8923ec0f12bcf4dddbfba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/cutScale/poor.png
// module id = 846
// module chunks = 0